import React, { Fragment } from 'react'

// icons
import { faCalculator } from '@fortawesome/free-solid-svg-icons'

// components
import Header from '../Header/Header'
import BotonBack from '../Utiles/BotonBack'
import Subtitulo from '../Utiles/Subtitulo'
import ItemListaPrecio from './ItemListaPrecio'

// route
import { withRouter } from 'react-router-dom'

// services
import routes from '../../Routes'
import HeaderActionsButtons from '../Custom/HeaderActionsButtons'
import HeaderPagination from '../Custom/HeaderPagination'
import usePagination from './hooks/usePagination'

const visibleButtons = {
    create: true,
    import: false,
    export: false,
    deleted: true,
    search: true,
    articuloPrecio: true
}

const ListasPrecios = ({ history }) => {

    const {
        listasPrecios,
        setIsLoad,
        page,
        totalRegister,
        totalPage,
        nextPage,
        previousPage,
        handleBuscador,
        disabledButton
    } = usePagination(history, true)

    return (
        <Fragment>
            <Header />
            <div className="container-fluid mt-3">
                <div className="alert alert-dismissible alert-secondary d-flex justify-content-between">
                    <BotonBack />
                    <Subtitulo icon={faCalculator} title={'Lista de Precios'} />
                </div>

                <HeaderActionsButtons
                    history={history}
                    routes={routes.LISTA_PRECIOS}
                    visibleButtons={visibleButtons}
                    handleBuscador={handleBuscador}
                    disabledButton={disabledButton}
                />
                <HeaderPagination
                    page={page}
                    totalPage={totalPage}
                    previousPage={previousPage}
                    nextPage={nextPage}
                    totalRegister={totalRegister}
                />

                <table className="table table-striped mt-3 text-center">
                    <thead>
                        <tr>
                            <th scope="col">Id</th>
                            <th scope="col">Nombre</th>
                            <th scope="col">Porcentaje Marcacion</th>
                            <th scope="col">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {listasPrecios.map((lista) => (
                            <ItemListaPrecio
                                key={parseInt(lista.id)}
                                lista={lista}
                                setIsLoad={setIsLoad}
                            />
                        ))}
                    </tbody>
                </table>
            </div>
        </Fragment>
    )
}

export default withRouter(ListasPrecios)
